import apiCall from "../../utils/apiCall";
import {apiUrls} from "../../constants/apiUrls";
import {RightCreate, UpdateRight} from "../../types/api/authorization/right.types";

export const rightService = {
    create: (right: RightCreate) =>
        apiCall.post(apiUrls.authorization.right.create, right),

    update: (right: UpdateRight) =>
        apiCall.post(apiUrls.authorization.right.update, right),

    getAll: () =>
        apiCall.get(apiUrls.authorization.right.getAll)
}